import { Controller } from "stimulus"
import $ from 'jquery';
import {blockBody,unblockBody} from './blockUI_controller'
// import {get_popup} from './popup_controller'
const {setSessionVar} = require('./sessionStorage_controller')


import Swal from 'sweetalert2/dist/sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'
// import '@sweetalert2/theme-borderless/borderless.scss'
import {set_locale} from "./localize_controller";

String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim());
};

let clear_session_and_save_url = (url) => new Promise((resolve, reject) =>{
    setSessionVar('shopping_cart','','delete',false);

    // setSessionVar('has_reservation','','delete',false).then(
    //     has_reservation => {
            sessionStorage.setItem('inPayProccess','true');
            sessionStorage.setItem('need_clean','true');
            resolve({
                success: true,
                url: url
            })
    //     }
    // )

})



export function sweet(launch,showLoad,showConfirmationButton,confirmButtonText,showCancelButton,cancelButtonText,showDenyButton,denyButtonText,title,text,icon) {

    if(launch){
        let config = {};
        if(showLoad){
            let timerInterval;
            config = {
                allowOutsideClick: true,
                timer: 5000,
                didOpen: ()=> {
                    Swal.showLoading();
                }
            }
        }
        config.backdrop= `#354052`;
        if(!title.isEmpty()){ config.title = title; }
        if(!text.isEmpty()){config.text = text; }
        if(!icon.isEmpty()){config.icon = icon; }
        if(showConfirmationButton){config.showConfirmButton = showConfirmationButton; }
        if(!confirmButtonText.isEmpty()){config.confirmButtonText = confirmButtonText; }
        if(showCancelButton){config.showCancelButton = showCancelButton; }
        if(!cancelButtonText.isEmpty()){config.cancelButtonText = cancelButtonText; }
        if(showDenyButton){config.showDenyButton = showDenyButton; }
        if(!denyButtonText.isEmpty()){config.denyButtonText = denyButtonText; }


        Swal.fire(config);
    }

}

export function confirm_cart(url){
    let pay_btn = $('#finish_action_btn');
    if(pay_btn !== undefined){
        pay_btn.unblock();
    }

    // get_popup('with_rent_redirect_to_pay').then(
    //     with_rent_redirect_to_pay => {
    //         Swal.fire({
    //             title: with_rent_redirect_to_pay.title || 'Proceso de pago',
    //             text: with_rent_redirect_to_pay.description || "Usted sera redireccionado a la pasarela de pago de nuestra empresa, ¿Desea continuar?",
    //             icon: with_rent_redirect_to_pay.icon || 'info',
    //             showCancelButton: true,
    //             confirmButtonText: I18n.t('global.popup.with_rent_redirect_to_pay_confirm'),
    //             cancelButtonText: I18n.t('global.popup.with_rent_redirect_to_paycancel'),
    //             reverseButtons: true,
    //             allowOutsideClick: false,
    //             // backdrop: `#354052`,
    //             backdrop: `rgba(255,255,255,1)`,
    //             customClass: {
    //                 loader: 'custom-loader',
    //                 confirmButton: 'btn btn-success',
    //                 cancelButton: 'btn btn-secondary margin-right-15'
    //             },
    //             buttonsStyling: false
    //         })
    //             .then(async (result) => {
    //                 blockBody();
    //
    //                 if (result.isConfirmed) {
    //                     let clear_and_save = await clear_session_and_save_url(url);
    //                     if(clear_and_save.success){
    //                         location.href = clear_and_save.url;
    //                     }
    //                 }
    //                 else{
    //                     $.ajax({
    //                         url: location.origin+`/${sessionStorage.getItem('locale')}/change_history_status`,
    //                         data: {
    //                             format: 'json'
    //                         },
    //                         type: "GET",
    //                         success: function (set_data) {
    //                             if(set_data.success){
    //                                 setSessionVar('','','clear',false).then(
    //                                     check => {
    //                                         set_locale().then(
    //                                             locale => {
    //                                                 if (check.success) {
    //                                                     window.location.href = `/${locale.locale}`;
    //                                                 } else {
    //                                                     console.log(check);
    //                                                 }
    //                                             });
    //                                     }
    //                                 )
    //
    //                             }else{
    //                                 console.log(set_data);
    //                             }
    //                         }
    //                     });
    //
    //                 }
    //             })
    //     }
    // )

}

export function loaded(show,title, text,icon) {
    let timerInterval;
    Swal.fire({
        title: title,
        text: text || '',
        icon: icon||'',
        showConfirmButton: false,
        timer: 2500,
        allowOutsideClick: false,
        backdrop: `rgba(255,255,255,1)`,
        customClass: {
            loader: 'custom-loader'
        },
        loaderHtml: '<div class="loader-container">\n' +
            '<svg id="loader" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 640 480" shape-rendering="geometricPrecision" text-rendering="geometricPrecision"><style><![CDATA[#loader-c1_tr {animation: loader-c1_tr__tr 4000ms linear infinite normal forwards}@keyframes loader-c1_tr__tr { 0% {transform: translate(230.039672px,229.978059px) rotate(0.414097deg)} 12.5% {transform: translate(230.039672px,229.978059px) rotate(90deg);animation-timing-function: cubic-bezier(0.42,0,0.58,1)} 25% {transform: translate(230.039672px,229.978059px) rotate(180deg)} 37.5% {transform: translate(230.039672px,229.978059px) rotate(270deg)} 50% {transform: translate(230.039672px,229.978059px) rotate(360deg)} 100% {transform: translate(230.039672px,229.978059px) rotate(360deg)}} #loader-c2_tr {animation: loader-c2_tr__tr 4000ms linear infinite normal forwards}@keyframes loader-c2_tr__tr { 0% {transform: translate(229.949235px,230.005692px) rotate(-180deg)} 12.5% {transform: translate(229.949235px,230.005692px) rotate(-180deg)} 15% {transform: translate(229.949235px,230.005692px) rotate(-173.143456deg)} 20% {transform: translate(229.949235px,230.005692px) rotate(-120.416427deg)} 22.5% {transform: translate(229.949235px,230.005692px) rotate(-96.974352deg)} 25% {transform: translate(229.949235px,230.005692px) rotate(-89.997952deg)} 37.5% {transform: translate(229.949235px,230.005692px) rotate(0deg)} 50% {transform: translate(229.949235px,230.005692px) rotate(90deg)} 62.5% {transform: translate(229.949235px,230.005692px) rotate(180deg)} 100% {transform: translate(229.949235px,230.005692px) rotate(180deg)}} #loader-c3_tr {animation: loader-c3_tr__tr 4000ms linear infinite normal forwards}@keyframes loader-c3_tr__tr { 0% {transform: translate(229.981829px,230.292668px) rotate(90deg)} 25% {transform: translate(229.981829px,230.292668px) rotate(90deg)} 37.5% {transform: translate(229.981829px,230.292668px) rotate(180deg)} 50% {transform: translate(229.981829px,230.292668px) rotate(270deg)} 62.5% {transform: translate(229.981829px,230.292668px) rotate(360deg)} 75% {transform: translate(229.981829px,230.292668px) rotate(450deg)} 100% {transform: translate(229.981829px,230.292668px) rotate(450deg)}} #loader-c4_tr {animation: loader-c4_tr__tr 4000ms linear infinite normal forwards}@keyframes loader-c4_tr__tr { 0% {transform: translate(229.961857px,230.033277px) rotate(90deg)} 37.5% {transform: translate(229.961857px,230.033277px) rotate(90deg)} 50% {transform: translate(229.961857px,230.033277px) rotate(180deg)} 62.5% {transform: translate(229.961857px,230.033277px) rotate(270deg)} 75% {transform: translate(229.961857px,230.033277px) rotate(360deg)} 87.5% {transform: translate(229.961857px,230.033277px) rotate(450deg)} 100% {transform: translate(229.961857px,230.033277px) rotate(450deg)}}]]></style><defs><filter id="loader-c1-filter" x="-400%" width="600%" y="-400%" height="600%"><feComponentTransfer id="loader-c1-filter-opacity-0" result="result"><feFuncA id="loader-c1-filter-opacity-0-A" type="table" tableValues="0 1"/></feComponentTransfer></filter></defs><g id="loader-g1" transform="matrix(.70445 0.709754-.709754 0.70445 231.300361-95.231436)"><g id="loader-c1_tr" transform="translate(230.039672,229.978059) rotate(0.414097)"><rect id="loader-c1" width="30" height="30" rx="0" ry="0" transform="translate(-29.978059,-29.960328)" opacity="0.98" filter="url(#loader-c1-filter)" fill="#ef3e33" stroke-width="0"/></g><g id="loader-c2_tr" transform="translate(229.949235,230.005692) rotate(-180)"><rect id="loader-c2" width="30" height="30" rx="0" ry="0" transform="translate(-29.994306,0.051837)" fill="#ef3e33" stroke-width="0"/></g><g id="loader-c3_tr" transform="translate(229.981829,230.292668) rotate(90)"><rect id="loader-c3" width="30" height="30" rx="0" ry="0" transform="translate(-0.018269,-30.018339)" fill="#ef3e33" stroke-width="0"/></g><g id="loader-c4_tr" transform="translate(229.961857,230.033277) rotate(90)"><rect id="loader-c4" width="30" height="30" rx="0" ry="0" transform="translate(0.038143,-0.033277)" fill="#ef3e33" stroke-width="0"/></g></g></svg>'+

            '</div>',
        // backdrop: `#354052`,
        didOpen: () => {
            Swal.showLoading()
        }
    });
}

export default class extends Controller {

    connect() {

    }
}